import { BaseEnum } from '../../../enums/baseEnum';

const listRecruitmentStatusEnum: Array<RecruitmentStatus> = [];

export class RecruitmentStatus extends BaseEnum {
  static MOV_REQUEST_DRAFT = new RecruitmentStatus(-1, 'MovimentRequestDraft', 'Rascunho Movimentações', 'warning');
  static DRAFT = new RecruitmentStatus(0, 'Draft', 'Rascunho', 'warning');
  static PUBLISHED = new RecruitmentStatus(1, 'Published', 'Publicado', 'info');
  static IN_PROCESS = new RecruitmentStatus(2, 'InProcess', 'Em andamento', 'primary');
  static FINISHED = new RecruitmentStatus(3, 'Finished', 'Finalizado', 'success');
  static INTERRUPTED = new RecruitmentStatus(4, 'Interrupted', 'Interrompido', 'danger');
  static STOPPED = new RecruitmentStatus(5, 'Stopped', 'Pausada', 'warning');

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string
  ) {
    super(id, value, label, className);
    listRecruitmentStatusEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listRecruitmentStatusEnum;
  }

  public static getById(id: number): RecruitmentStatus | undefined {
    return listRecruitmentStatusEnum.find(item => item.id === id);
  }

  public static getBy(value: string): RecruitmentStatus | undefined {
    return listRecruitmentStatusEnum.find(item => item.value === value);
  }
}
